import React from "react";
import { Provider } from "react-redux";

import store from "./src/state/store";

// eslint-disable-next-line react/display-name,react/prop-types
export default function wrapWithProvider({ element }) {
  return <Provider store={store}>{element}</Provider>;
}
